'use client';

import { c as _c } from "react/compiler-runtime";
import { type JobRollUp, rollUpJobs } from '@shared/all/helpers/runningJobs';
import { Activity } from 'lucide-react';
import { useRunners } from '../../hooks/useRunners';

// Waiting is amber and still, working is the only state that moves, so the two
// cannot be confused at a glance.
const LOOK: Record<JobRollUp, {
  className: string;
  title: string;
}> = {
  attention: {
    className: 'text-amber-400',
    title: 'A job is waiting for you'
  },
  working: {
    className: 'animate-pulse text-sky-400',
    title: 'Jobs running'
  },
  idle: {
    className: '',
    title: 'No jobs running'
  }
};

/**
 * The Running jobs section's icon, carrying the fleet's rolled-up state. The
 * same node is the heading icon on a wide screen and the whole trigger on a
 * narrow one, so both read the fleet without the section being open.
 */
const RunningJobsIcon = t0 => {
  const $ = _c(6);
  const {
    size,
    idleClassName: t1
  } = t0;
  const idleClassName = t1 === undefined ? "" : t1;
  const {
    sessions,
    activities,
    updateState
  } = useRunners();
  const rollUp = rollUpJobs(sessions, activities, Object.values(updateState));
  const look = LOOK[rollUp];
  const t2 = rollUp === "idle" ? idleClassName : look.className;
  let t3;
  if ($[0] !== size || $[1] !== t2) {
    t3 = <Activity size={size} className={t2} />;
    $[0] = size;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== look.title || $[4] !== t3) {
    t4 = <span title={look.title} data-id="running-jobs-status">{t3}</span>;
    $[3] = look.title;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};
export default RunningJobsIcon;